const discover = {
  "discover.page_title": "了解睛漾水凝®",
  "discover.trait_01.body": "鏡片隔離色素不直接接觸眼睛，且色圈不降低透氧率，讓雙眼自在呼吸。",
  "discover.trait_01.title": "獨特 BWIC™ 透氧隔色科技",
  "discover.trait_02.body": "阻隔紫外線對眼睛的傷害，符合美國國家標準協會 ANSI 抗紫外線*第二級 UV 防護標準，平均阻隔 81% UVA 及 97% UVB。",
  "discover.trait_02.title": "超強全天 UV 防禦",
  "discover.trait_03.body": "透過多層次疊色及細膩的手繪紋路設計，增強立體感，讓您眼神明亮通透，深邃放大。",
  "discover.trait_03.title": "光透疊色揉合設計",
  "discover.trait_04.item_01.body": "滑順鏡片邊緣設計，減少眨眼時帶來的刺激及不適，異物感 OUT。",
  "discover.trait_04.item_01.title": "輕薄鏡片",
  "discover.trait_04.item_02.body": "獨特 LACREON® 水凝科技**，將保濕因子 20 小時鎖在鏡片中不隨時間或眨眼流失，幫助穩定淚水保濕，減少眼睛乾澀。",
  "discover.trait_04.item_02.title": "保濕鎖水",
  "discover.trait_04.item_03.body": "鏡片設計柔軟好戴，減少眼睛摩擦力，維持全日極佳舒適的配戴感受。",
  "discover.trait_04.item_03.title": "舒適好戴",
  "discover.trait_04.title": "精心打造，享受全日水潤舒適",
}

export const try_lenses = {
  "try_lenses.block_title": "線上試戴 <span>安視優®睛漾水凝®系列</span> AR濾鏡體驗",
  "try_lenses.virtual_mirror": "立即試戴",
}

export const product_range = {
  "product_range.block_title": "找到最適合您的 <span>安視優®睛漾水凝®</span>",
  "product_range.button.classic": "了解經典/璀璨系列",
  "product_range.button.fresh": "了解花眸/甜漾系列",
}

const discover_references = {
  "discover_references": "<p>*抗紫外線的隱形眼鏡不可用以替代太陽眼鏡，因為隱形眼鏡無法完全遮蓋眼睛及其周圍區域，建議配戴隱形眼鏡並搭配太陽眼鏡給雙眼全方位的紫外線防護。</p> <p>**鏡片以 LACREON® 水凝科技在製程中添加 PVP 保濕因子，提高 etafilcon A 水膠材質鏡片的保水性，經模擬實驗證實經過 20 小時，PVP 保濕因子不會隨時間而流失，減少眼睛乾澀，配戴較舒適。</p>"
}

// export default discover;
export default {
  ...discover,
  ...try_lenses,
  ...product_range,
  ...discover_references
}
